import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: theme.globalMarginMobile,
    paddingLeft: theme.globalMarginMobile,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.secondary,
    [theme.breakpoints.up("sm")]: {
      textAlign: "center",
      paddingLeft: theme.globalMarginDesktop,
      paddingRight: theme.globalMarginDesktop,
    },
    [theme.breakpoints.down("xs")]: {
      overflowX: "scroll",
      overflowY: "hidden",
      whiteSpace: "nowrap",
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      "& .MuiButton-text": {
        color: theme.palette.primary.main,
      },
    },
  },
}));

const ToolBar = (props) => {
  const { className } = props;
  const classes = useStyles();

  return (
    <div className={`${className ? className : ""}`}>
      <div className={`${classes.toolbar}`}>{props.children}</div>
    </div>
  );
};

export default ToolBar;
